import { CertificateType } from "./Certificate";

/*
    const shinyHslByType = {
      [CertificateType.GOLD]: [37, 91, 27],
      [CertificateType.SILVER]: [180, 4, 27],
      [CertificateType.BRONZE]: [20, 40, 20],
      [CertificateType.GREEN]: [120, 80, 18],
    }
*/

const themeColors = {
  [CertificateType.GREEN]: 'hsl(120, 40%, 18%)',
  [CertificateType.BRONZE]: 'hsl(20, 20%, 20%)',
  [CertificateType.SILVER]: 'hsl(180, 4%, 27%)',
  [CertificateType.GOLD]: 'hsl(37, 45%, 27%)',
}

const themeClasses = {
  [CertificateType.GREEN]: 'challenge-green',
  [CertificateType.BRONZE]: 'challenge-bronze',
  [CertificateType.SILVER]: 'challenge-silver',
  [CertificateType.GOLD]: 'challenge-gold',
}

function setThemeColor(color) {
  let themeColor = document.querySelector('meta[name="theme-color"]');
  if (!themeColor) {
    themeColor = document.createElement('meta');
    themeColor["name"] = 'theme-color';
    document.head.appendChild(themeColor);
  }
  themeColor.setAttribute('content', color);
}

function getThemeColor() {
  let themeColor = document.querySelector('meta[name="theme-color"]');
  if (!themeColor) {
    return undefined;
  }
  return themeColor.getAttribute('content');
}

function getTheme() {
  const themeColor = getThemeColor()
  Object.entries(themeColors).forEach(([key, value]) => {
    if (value === themeColor) {
      return key;
    }
  });
  return undefined;
}

export const useThemeUpdater = () => {

  const updateTheme = (type: CertificateType) => {
    const oldTheme = getTheme()
    if (oldTheme === type) {
      return;
    }
    const rootElement = document.getElementById('root'); 
    rootElement.classList.remove("challenge-green");
    rootElement.classList.remove("challenge-bronze");
    rootElement.classList.remove("challenge-silver");
    rootElement.classList.remove("challenge-gold");
    rootElement.classList.add(themeClasses[type]);
    setThemeColor(themeColors[type]);
  }

  return {
    updateTheme
  }
}